import axios from 'axios';
import Bowser from 'bowser';
import { get } from 'lodash';

interface IPageScrollEvent {
  eventType: string;
  deviceId: string;
  eventProperties: {
    browser?: {
      name: string;
      version: string;
    };
    canonicalUrl?: string;
    contentGroup?: string;
    documentHeight?: number;
    os?: {
      name: string;
      version: string;
      versionName: string;
    }
    pageComponentName?: string;
    pageComponentVersion?: number;
    path?: string;
    platform?: {
      type: string;
      vendor: string;
    };
    referrer?: string;
    screenHeight?: number;
    screenWidth?: number;
    scrollIntervalSize?: number;
    scrollPercentage?: number;
    scrollPosition?: number;
    url?: string;
  };
}

export const SCROLL_INTERVAL_SIZE = 500;

export default async function trackPageScroll({
  contentGroup,
  pageComponentName,
  pageComponentVersion,
}: IPageScrollEvent["eventProperties"]) {
  if (pageComponentName == null) throw new Error('Missing Page Component Name');
  if (pageComponentVersion == null) throw new Error('Missing Page Component Version');

  const anonymousId = get(window, 'analytics.user') != null
    ? window.analytics.user().anonymousId()
    : null;

  if (anonymousId && typeof window !== 'undefined') {
    try {
      const browserProps = Bowser.parse(window.navigator.userAgent);
      const trackBody: IPageScrollEvent = {
        eventType: 'pageScroll',
        deviceId: anonymousId,
        eventProperties: {
          browser: browserProps.browser,
          canonicalUrl: get(document.querySelector('link[rel="canonical"]'), 'href'),
          contentGroup,
          documentHeight: document.body.clientHeight,
          os: browserProps.os,
          pageComponentName,
          pageComponentVersion,
          path: window.location.pathname,
          platform: browserProps.platform,
          referrer: document.referrer,
          screenHeight: window.innerHeight,
          screenWidth: window.innerWidth,
          scrollIntervalSize: SCROLL_INTERVAL_SIZE,
          scrollPercentage: Number(Number(window.scrollY / document.body.clientHeight).toFixed(3)),
          scrollPosition: window.scrollY,
          url: window.location.href,
        }
      };
      await axios.post(`${UPSOLVE_API_URL}/v1/notifications/amplitude`, trackBody);
    } catch (error) {
      console.warn(error);
    }
  }

}
